<div
  class="mr-0 d-flex justify-content-center"
  (click)="goToUser()"
>
  <i class="icon profile"></i>
</div>
